if (!customElements.get('fake-select')) {
  class FakeSelect extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
      this.selectChanged = new CustomEvent('fake-select:changed', {
        bubbles: true,
        value: this.value
      });
    }
      
    connectedCallback() {
      this.dropdown = this.querySelector('[data-dropdown]');
      this.selectValue = this.querySelector('[data-fake-select-value]');
      this.rotateEl = this.querySelector('[data-rotate]');
      this.expandingParent = this.closest('[data-fake-select-expanding-wrapper]');

      window.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.close();
          return;
        }
      });

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-dropdown-action]');
        if (!clickedElement) return;

        const {
          dropdownAction: action,
          value,
          label
        } = clickedElement.dataset;

        switch (action) {
          case 'toggle-dropdown':
            this.isOpen = !this.isOpen;

            if (this.isOpen) {
              this.open();
              return;
            }

            this.close();

          break;
            case 'select':
              const id_value = clickedElement.closest('li').id;
              this.selectValue.setAttribute('aria-labelledby', id_value)

              this.value = value;
              this.dispatchEvent(this.selectChanged);
              this.selectValue.innerHTML = label;
              const realSelect = this.querySelector('select[data-real-select]');
              if (realSelect) {
                realSelect.value = value;
                realSelect.dispatchEvent(new Event('change'));
                realSelect.click();
              }
            break;
            default: break;
        }
      });
    }

    open() {
      if (!this.dropdown) return;
      this.dropdown.style.height = `${this.dropdown.scrollHeight}px`;
      if (this.expandingParent) this.expandingParent.style.height = `${this.expandingParent.scrollHeight + this.dropdown.scrollHeight}px`;
      if (this.rotateEl) this.rotateEl.style.transform = 'rotate(-180deg)';
      this.style.zIndex = 100;
      this.classList.add('open');
      this.dropdown.addEventListener('mouseleave', this.close, { once: true });

      const button = this.querySelector('button');
      button.setAttribute('aria-expanded', 'true');
      
      if (this.dropdown.getAttribute('data-no-reposition')) return;
      const this_rect = this.dropdown.getBoundingClientRect();

      if (this_rect.x < 32) {
        this.dropdown.style.left = 0;
        this.dropdown.classList.remove(`-translate-x-1/2`, `left-1/2`);
      }
    }

    close() {
      if (!this.dropdown) return;
      this.dropdown.style.height = '0px';
      if (!this.dropdown.getAttribute('data-no-reposition')) {
        this.dropdown.style.left = null;
        this.dropdown.style.transform = null;
      };

      if (this.expandingParent) this.expandingParent.style.height = null;
      if (this.rotateEl) this.rotateEl.style.transform = null;
      this.isOpen = false;
      this.removeEventListener('mouseleave', this.close);
      setTimeout(() => {
        this.style.zIndex = null, 300;
        this.classList.remove('open');
      });

      const button = this.querySelector('button');
      button.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('fake-select', FakeSelect);
}